module.exports = __webpack_public_path__ + "img/shopee_9thb_0001.75ac9848.png";